import { Button, Flex, Heading, Image, Stack, Text, VStack } from '@chakra-ui/react'
import { ChevronRightIcon } from '@src/components/sco/icons'
import { useBreakpointContext } from '@src/components/sco/utilities/BreakpointProvider'
import { NextLink } from '@src/components/sco/utilities/NextLink'

type PlaybookCardProps = {
  bgColor?: string
  buttonLabel?: string
  direction?: any
  illustration?: string
  summary?: string
  tag?: string
  tagColor?: string
  targetUrl?: string
  title?: string
}

export const PlaybookCard = (props: PlaybookCardProps) => {
  const { summary, targetUrl, title, tag, tagColor, bgColor, illustration, direction } = props
  const { getBreakpointValue } = useBreakpointContext()

  return (
    <Flex
      align={'flex-start'}
      bg={`linear-gradient(to bottom right, ${bgColor}20, ${bgColor}50)`}
      bgColor={'colorPalette.container'}
      borderRadius={'2xl'}
      borderTopColor={'whiteAlpha.100'}
      borderTopStyle={'solid'}
      borderTopWidth={'1px'}
      boxShadow={'sm'}
      cursor={'pointer'}
      flex={1}
      paddingX={getBreakpointValue([10, 10, 16, 16, 16])}
      paddingY={getBreakpointValue([10, 10, 16, 16, 16])}
      position={'relative'}
      transition={'all 0.2s ease-in-out'}
      width={'100%'}
      _hover={{
        bgGradient: `linear(to-br, ${bgColor}30, ${bgColor}60)`,
      }}
    >
      <Stack
        asChild
        direction={direction}
        gap={20}
        justify={'flex-start'}
        position={'relative'}
        width={'full'}
      >
        <NextLink href={targetUrl || '#'}>
          <Flex
            align={'center'}
            aspectRatio={4 / 3}
            bgColor={'blackAlpha.500'}
            borderRadius={'2xl'}
            boxShadow={'lg'}
            flex={1}
            hidden={getBreakpointValue([true, true, true, false])}
            justify={'center'}
            position={'relative'}
          >
            <Image
              alt={title}
              height={'full'}
              objectFit={'cover'}
              src={illustration}
              transition={'all 0.1s ease-in'}
              width={'full'}
              zIndex={1}
            />
          </Flex>
          <VStack alignItems={'flex-start'} flex={1} gap={5} justifyContent={'center'}>
            <Heading size={getBreakpointValue(['3xl', '3xl', '4xl', '5xl'])}>{title}</Heading>
            <Text fontSize={getBreakpointValue(['md', 'lg', 'xl', 'lg'])}>{summary}</Text>
            <Button bgColor={tagColor} size={'lg'}>
              {props.buttonLabel || 'View Playbook'}
              <ChevronRightIcon />
            </Button>
          </VStack>
        </NextLink>
      </Stack>
    </Flex>
  )
}
